import React,{useState} from "react";
import { Link, useLocation  } from 'react-router-dom';
import Meta from "../../BiolyBlack/Meta";

function HeaderBlack()
{
   const [isMenuOpen, setIsMenuOpen] = useState(false);	
   
   const [showModal, setShowModal] = useState(false);

   const location = useLocation();

   const metaInfo = {
    "/": {
      title: "Modern Appforce – Ultimate Media Player App for Android TV",
      description: "Experience flawless media player with Modern Appforce, the powerful media player app for Android TV. Enjoy live TV, custom playlists, multi-language support & more. Download now for a next-level entertainment journey.",
      canonical: "https://modernappforce.com"
    },
    "/terms-conditions": {
      title: "Terms and Conditions | Modern Appforce Pro for Android TV",
      description: "Review the terms and conditions for using Modern Appforce Pro. Understand your rights, responsibilities, and our policies for the Android TV media player experience.",
      canonical: "https://modernappforce.com/terms-conditions"
    },
    "/install-modern-appforce": {
      title: "Download Modern Appforce Pro | Media Player for Android TV",
      description: "Download Modern Appforce Pro today and transform your Android TV into a complete entertainment hub. Fast, reliable, and user-friendly media player experience.",
      canonical: "https://modernappforce.com/install-modern-appforce"
    },
    "/contact-us": {
      title: "Contact Us | Modern Appforce Pro for Android TV",
      description: "Have questions about Modern Appforce Pro? Get in touch with our support team for assistance, feedback, or general inquiries regarding our Android TV media player.",
      canonical: "https://modernappforce.com/contact-us"
    },
    "/privacy-policy": {
      title: "Privacy Policy | Modern Appforce Pro Media Player",
      description: "Learn how Modern Appforce Pro collects, uses, and protects your information. Your privacy matters while enjoying uninterrupted media on your Android TV.",
      canonical: "https://modernappforce.com/privacy-policy"
    },
   };

    const currentMeta = metaInfo[location.pathname] || {
      title: "Bauwerk AGT Cooperation | Fachmännischer Hausbau und Renovierung",
      description: "Entdecken Sie moderne Bau- und Renovierungsdienstleistungen mit Bauwerk AGT Cooperation, den besten Baudienstleistungen in Deutschland. Wir bauen, gestalten und verwandeln Häuser mit fachmännischem Können und fortschrittlichen Techniken.",
      canonical: "https://bauwerk-agt-cooperation.com/de"
    };


   const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };  
   const scrollToNode = (node) => {
		node.scrollIntoView({ behavior: 'smooth' });
	}
    return(
        <>
        
   <Meta  
          title={currentMeta.title}
          description={currentMeta.description}
          canonical={currentMeta.canonical}
        />          
	<div class="sb-header header-shadow header-dark">
		<div class="container">


			<div class="sb-header-container">
				

                <div class="logo" data-mobile-logo="imgs/home_four/modren-appdorce-logo.png" data-sticky-logo="imgs/home_four/modren-appdorce-logo.png">
                	<Link to="/"><img src="imgs/home_four/modren-appdorce-logo.png" alt="logo"/></Link>
				</div>
				

				<div class={`burger-menu ${isMenuOpen ? "menu-open" : ""}`} onClick={() => toggleMenu()}>
					<div class="line-menu line-half first-line"></div>
					<div class="line-menu"></div>
					<div class="line-menu line-half last-line"></div>
				</div>


                <nav class={`sb-menu separate-line submenu-top-border submenu-scale ${isMenuOpen ? "menu-open" : ""}`}>
                	<ul className="header-menu-list">
            <li className={location.pathname === "/" ? "current-menu" : ""}><Link to="/">Home</Link></li>
						<li className={location.pathname === "/faq" ? "current-menu" : ""}><Link to="/faq">FAQ</Link></li>
            <li className={location.pathname === "/terms-conditions" ? "current-menu" : ""}><Link to="/terms-conditions">Terms & Conditions</Link></li>
            <li className={location.pathname === "/privacy-policy" ? "current-menu" : ""}><Link to="/privacy-policy">Privacy Policy</Link></li>
						<li className={location.pathname === "/contact-us" ? "current-menu" : ""}><Link to="/contact-us">Contact Us</Link></li>
						<li class="submenu-right" onClick={() => setShowModal(true)}><a href="javascript:void(0)">Become Reseller</a></li>
						<li class="submenu-right"><Link to="/install-modern-appforce">Download Modern AppForce</Link></li>
                    </ul>
                </nav>

				{showModal && (
        <div id="myModales" className="custom-modal">
          <div className="modal-contentes">
            <span className="closes-modal-btn" onClick={() => setShowModal(false)}>
              &times;
            </span>
            <h2>Please Contact Support WhatsApp</h2>
            <hr />
			<p className="whatsapp-line"><a href="https://api.whatsapp.com/send?phone=+49163 4559202&amp;text=Modern Appforce Best Media Player App&amp;source=&amp;data=&amp;app_absent" target="_blank" class="whatsapp_button_control"> <img src="https://wolfed.b-cdn.net/appforceclassic/WhatsApp.webp" alt="whatapps"/> +49 (163) 4559-202</a></p>
          </div>
        </div>
      )}

			</div>

		</div>
	</div>

        </>
    )
}
export default HeaderBlack